import { Album } from "../../types/Album";
import { Artist } from "../../types/Artist";
import { PlaylistItem } from "../../types/PlaylistItem";
import { Track } from "../../types/Track";

export const doesTrackMatchPlaylistItem = (
    item: PlaylistItem,
    artist?: Artist,
    album?: Album,
    track?: Track,
) => {
    if (!item) {
        return false;
    }

    return item.artistName === artist?.name &&
        item.albumYear === album?.year &&
        item.albumTitle === album?.title &&
        item.track?.number === track?.number &&
        item.track?.name === track?.name;
}